module.exports = __webpack_public_path__ + "img/巴音王子.c10bc8e1.jpg";